<template>
  <button
    @click="$emit('click', $event)"
    :class="[
      'check-card check-card-btn shadow white rounded relative',
      {
        'check-card--active': active,
      },
      {
        'shadow--hover': !disabled,
      },
      {
        'text--disabled': disabled,
      },
    ]"
    :disabled="disabled"
  >
    <div v-if="tooltip" class="absolute check-card-btn__hint">
      <v-tooltip top color="primary">
        <template v-slot:activator="{ on, attrs }">
          <v-icon small v-bind="attrs" v-on="on" color="navy lighten-1">
            mdi-help-circle-outline
          </v-icon>
        </template>
        <span v-text="tooltip" />
      </v-tooltip>
    </div>
    <div class="d-flex justify-center align-center pt-10">
      <v-img
        v-if="icon"
        :class="[
          'mx-auto',
          {
            'text--disabled': disabled,
          },
        ]"
        width="32"
        height="32"
        contain
        :src="icon"
      />
    </div>
    <div class="d-flex justify-center align-center pb-4">
      <div class="text-center body-1 font-weight-bold px-6">
        <slot />
      </div>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    icon: { type: String, required: true },
    tooltip: { type: String, required: false },
  },
  data() {
    return {
      hintIcon: require("@/assets/ico-question-mark.svg"),
    }
  },
}
</script>

<style scoped>
.check-card-btn {
  width: 160px;
  height: 160px;
  display: grid;
  grid-template-rows: 3fr 2fr;
}

.check-card-btn__hint {
  top: 6px;
  left: 6px;
}

.check-card-btn__hint i {
  display: block;
}
</style>
